import axios from "axios";
import React, { Component } from "react";
import cookie from "react-cookies";
import { Alert, Button, Container, Spinner } from "reactstrap";
import constants from "../../Constants";
import "../integrations/integrations.css";
import "./team.css";

const baseURL = constants.baseURL;

const ROLE_ACCESS = {
  admin: [
    "Book trips",
    "View org trips & billing",
    "Invite & manage team",
    "Edit business profile",
    "Pay invoices",
  ],
  member: ["Book trips", "View org trips & billing"],
  viewer: ["View org trips & billing (read-only)"],
};

class TeamAcceptPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      preview: null,
      token: null,
      accepting: false,
      error: "",
      done: false,
    };
  }

  componentDidMount() {
    document.title = "Accept team invite | QikTruck";
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      this.setState({ loading: false, error: "Invalid invitation link." });
      return;
    }
    if (!cookie.load("session-id-qt")) {
      const returnPath = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?redirect=${returnPath}`;
      return;
    }
    axios
      .get(`${baseURL}/merchant/team/invites/preview`, { params: { token } })
      .then((res) => {
        this.setState({ loading: false, preview: res.data, token });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err?.response?.data?.error || "Invitation not found or expired.",
        });
      });
  }

  accept = () => {
    const { token } = this.state;
    this.setState({ accepting: true, error: "" });
    axios
      .post(
        `${baseURL}/merchant/team/invites/accept`,
        { token },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("session-id-qt"),
          },
        }
      )
      .then((res) => {
        if (res.data?.["session-id-qt"]) {
          cookie.save("session-id-qt", res.data["session-id-qt"], {
            path: "/",
            maxAge: 86400 * 180,
            secure: true,
          });
        }
        if (res.data?.promocode) {
          cookie.save("promocode", res.data.promocode, { path: "/", maxAge: 86400, secure: true });
        }
        this.setState({ accepting: false, done: true });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1800);
      })
      .catch((err) => {
        this.setState({
          accepting: false,
          error: err?.response?.data?.error || "Could not accept invitation.",
        });
      });
  };

  renderAccessList(role) {
    const items = ROLE_ACCESS[role] || ROLE_ACCESS.member;
    return (
      <ul className="qt-your-access-list mt-3 mb-0">
        {items.map((label) => (
          <li key={label}>
            <i className="mdi mdi-check-circle" aria-hidden="true" />
            {label}
          </li>
        ))}
      </ul>
    );
  }

  render() {
    const { loading, preview, accepting, error, done } = this.state;

    return (
      <div className="qt-integrations qt-team-accept">
        <Container className="py-5">
          <div className="qt-accept-card">
            <div className="qt-accept-card-body">
              <div className="qt-accept-icon">
                <i className="mdi mdi-email-check-outline" aria-hidden="true" />
              </div>
              <h1 className="h4 mb-2">Team invitation</h1>

              {loading ? (
                <div className="text-center py-4">
                  <Spinner color="primary" />
                  <p className="text-muted small mt-2 mb-0">Verifying invitation…</p>
                </div>
              ) : done ? (
                <Alert color="success" className="mb-0">
                  You joined the team. Redirecting to your dashboard…
                </Alert>
              ) : error ? (
                <Alert color="danger" className="mb-0">
                  {error}
                </Alert>
              ) : preview ? (
                <>
                  <p className="mb-2">
                    You&apos;ve been invited to join{" "}
                    <strong>{preview.orgName || "an organisation"}</strong> as{" "}
                    <span className={`qt-role-pill qt-role-pill--${preview.role}`}>
                      {preview.role}
                    </span>
                  </p>
                  <p className="text-muted small">
                    Sign in as <strong>{preview.email}</strong> to accept. You will only see organisation
                    trips and billing after accepting - not before.
                  </p>

                  <div className="qt-card mt-3">
                    <div className="qt-card-body py-3">
                      <div className="small text-muted text-uppercase mb-1">What you&apos;ll be able to do</div>
                      {this.renderAccessList(preview.role)}
                    </div>
                  </div>

                  <div className="qt-privacy-tip mt-3 mb-0">
                    <i className="mdi mdi-shield-lock-outline" aria-hidden="true" />
                    <div className="small">
                      This invitation is personal to your email. Do not forward the link. If you did not
                      expect this invite, close this page.
                    </div>
                  </div>

                  <Button color="primary" className="mt-4" onClick={this.accept} disabled={accepting} block>
                    {accepting ? <Spinner size="sm" /> : "Accept invitation"}
                  </Button>
                </>
              ) : null}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default TeamAcceptPage;
